// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3-BdL","header":"PatientQuestionnaire_header__WI5l5","info":"PatientQuestionnaire_info__1cw7E"};